var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Container, CssBaseline, Grid, Typography } from '@material-ui/core';
import { ProductImage } from '../../organisms/ProductImage';
import { Description } from '../../organisms/Description';
import { CouponName } from '../../organisms/CouponName';
import { SmartCheckUseButton } from '../../organisms/SmartCheckUseButton';
import { makeStyles } from '@material-ui/core/styles';
import { CompanyImage } from '../../organisms/CompanyImage';
import { SmartCheckHeaderImage } from '../../organisms/SmartCheckHeaderImage';
import { HtmlText } from '../../molcules/HtmlText';
import { CompanyName } from '../../organisms/CompanyName';
export var useSmartCheckCommonStyles = makeStyles(function (theme) { return ({
    section: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    centerSection: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        textAlign: 'center',
    },
    image: {
        width: '100%',
        height: '100%',
    },
    smartCheckUsedAt: {
        color: 'red',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    countDown: {
        color: 'red',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    countDownBigShopNameTemplate: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
    countDownAfter: {
        color: 'red',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    countDownAfterBigShopNameTemplate: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
}); });
/**
 * SmartCheck使用前テンプレート
 */
export var SmartCheckLightBeforeUseTemplate = function (props) {
    var _a, _b, _c, _d;
    var classes = useSmartCheckCommonStyles();
    // 表示期間内で有効期限前の場合は、消込ボタンを及びコード入力欄を非表示にする
    var clearable = props.available.validity === 'before' && props.available.displayable === 'display';
    return (React.createElement(Container, { disableGutters: true },
        React.createElement(CssBaseline, null),
        React.createElement(Grid, { container: true, justifyContent: "center", alignItems: "center" },
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(CompanyImage, { imageUrl: props.data.companyImageUrl })),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(SmartCheckHeaderImage, { imageUrl: (_a = props.data.smartCheckImageUrl) === null || _a === void 0 ? void 0 : _a.smartCheckHeaderImageUrl })),
            props.layoutPattern === 'normal' || props.layoutPattern === 'product' ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(CompanyName, __assign({}, props.data.organizationName)))) : (React.createElement(React.Fragment, null)),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(CouponName, __assign({}, props.data.couponName))),
            props.data.productImage ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(ProductImage, __assign({}, props.data.productImage)))) : (React.createElement(React.Fragment, null)),
            !clearable ? (React.createElement(Grid, { item: true, xs: 12, className: classes.centerSection },
                React.createElement(SmartCheckUseButton, { imageUrl: (_b = props.data.smartCheckImageUrl) === null || _b === void 0 ? void 0 : _b.smartCheckUseButtonImageUrl }))) : (React.createElement(React.Fragment, null)),
            ((_c = props.data.smartCheckSetting) === null || _c === void 0 ? void 0 : _c.smartCheckUseButtonBottomText) ? (React.createElement(Grid, { item: true, xs: 12, className: classes.centerSection },
                React.createElement(HtmlText, { text: (_d = props.data.smartCheckSetting) === null || _d === void 0 ? void 0 : _d.smartCheckUseButtonBottomText }))) : (React.createElement(React.Fragment, null)),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(Typography, { align: "right", variant: 'body1' }, props.data.barcode.barcodeValue))),
        React.createElement(Description, __assign({}, props.data.description))));
};
//# sourceMappingURL=SmartCheckLightBeforeUseTemplate.js.map